// src/components/registro/AceptacionLegal.js
// (Portado de la web HolaVeci para el registro de HolaVeci Local, D-23.)
//
// Fila de aceptación legal: checkbox + link "Leer documento". Carga la
// versión activa del documento (título y HTML) al montar y guarda su
// checksum. Devuelve al padre { codigo, aceptado, checksum } vía onChange.

import React, { useEffect, useState } from 'react';
import {
  Box, Checkbox, FormControlLabel, Link, Dialog, DialogTitle, DialogContent,
  DialogActions, Button, Typography, Alert,
} from '@mui/material';
import { registroLocal } from '../../api/holaveciLocalApi';

export default function AceptacionLegal({ codigo, aceptado, onChange }) {
  const [doc, setDoc]         = useState(null);
  const [error, setError]     = useState('');
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    let cancelado = false;
    (async () => {
      try {
        const d = await registroLocal.documentoLegal(codigo);
        if (!cancelado) setDoc(d);
      } catch (e) {
        if (!cancelado) setError('No se pudo cargar el documento.');
      }
    })();
    return () => { cancelado = true; };
  }, [codigo]);

  const cambiar = (e) => {
    if (!doc) return;
    onChange({
      codigo:           doc.codigo,
      aceptado:         e.target.checked,
      checksumAceptado: doc.checksumSha256,
    });
  };

  return (
    <Box>
      <FormControlLabel
        control={<Checkbox checked={!!aceptado} onChange={cambiar} disabled={!doc} />}
        label={
          <Typography variant="body2">
            Acepto{' '}
            <Link component="button" type="button" onClick={(e) => { e.preventDefault(); setAbierto(true); }}>
              {doc?.titulo || codigo}
            </Link>
          </Typography>
        }
      />
      {error && <Alert severity="warning" sx={{ mt: 1 }}>{error}</Alert>}

      <Dialog open={abierto} onClose={() => setAbierto(false)} fullWidth maxWidth="md" scroll="paper">
        <DialogTitle>{doc?.titulo || codigo}</DialogTitle>
        <DialogContent dividers>
          {doc?.contenidoHtml ? (
            <Box dangerouslySetInnerHTML={{ __html: doc.contenidoHtml }} sx={{
              '& h1, & h2, & h3': { fontFamily: 'Fraunces', mt: 2 },
              '& p': { mb: 1.5 }, '& ul': { pl: 3 }, fontSize: 14,
            }} />
          ) : (
            <Typography>Cargando…</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAbierto(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
